<template>
<div>
  <btn @click="validate">Valider</btn>
  <modal v-model="show"
         :header="false"
         :backdrop="false"
         :footer="false">
    <h2>
      Surveillance Bact ADI sans bactériémies
    </h2>
    <steps :steps="iterator.steps" :stepStates="iterator.stepStates"></steps>
    <div v-if="completed">
      <btn @click="hide" type="default">Retour</btn>
    </div>
  </modal>
</div>
</template>
<script>
import StepIterator from '@/sui/tools/stepiterator'
import steps from '@/sui/components/steps'

const impl = {
  msg: {
    persist: `Si le problème persiste, merci de nous contacter via le
  formulaire de contact.`,
    impossible: `Impossible de valider la modalité, merci de vérifier qu'
aucune fiche n'a été saisie.`
  }
}

export default {
  name: 'validate-empty-bactadi',
  props: {
    surveillance: {
      type: Object,
      required: true
    }
  },

  data: function () {
    const steps = [
      {
        title: 'Validation de la surveillance Bact ADI',
        timeout: 10000,
        error: null,
        promise: true,
        run: function (vm, data, iteration) {
          this.progress.value = 100
          return vm.$store.dispatch(
            'surveillances/setEmptyBact',
            {
              s: vm.surveillance.id,
              v: true
            }
          ).then(
            (response) => {
              const { err, v } = response.data
              return {
                end: true,
                success: err == null && v != null,
                error: `${impl.msg.impossible} ${impl.msg.persist}`
              }
            }
          )
        },

        setError: function () {
          this.error = `${impl.msg.impossible} ${impl.msg.persist}`
        }
      }
    ]

    return {
      type: 'bactADI',
      show: false,
      enabled: true,
      iterator: new StepIterator(steps)
    }
  },

  computed: {
    completed: function () {
      return this.iterator.completed
    }
  },

  methods: {
    validate: function () {
      this.iterator.start(this)
      this.show = true
    },

    hide: function () {
      this.show = false
    }
  },

  components: {
    'steps': steps
  }
}
</script>
<style lang="less" scoped>
</style>
